var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('VideoComponentProfiel'),_c('profile-aseg'),_c('white-label'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }